import { Injectable, inject } from '@angular/core';
// import { Actions, Effect, ofType } from '@ngrx/effects';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, of } from 'rxjs';
import { map, mergeMap } from 'rxjs/operators';
import {
	ActionTypes,
	GetBanners,
	GetBannersSuccess,
	GetBannersError,
	GetBannersForProduct,
	GetBannersForProductSuccess,
	GetBannersForProductError,
	GetBannersForStore,
	GetBannersForStoreSuccess,
	GetBannersForStoreError,
	GetPopularJewellers,
	GetPopularJewellersError,
	GetPopularJewellersSuccess
} from './root.actions';
import { Helper } from "../../shared/services/Helper.service";
import { RootService } from "../../root/services/root.service";

@Injectable()
export class RootEffects {

	// @Effect()
	// GetBanners$ = this.actions$.pipe(
	GetBanners$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.GetBanners),
			map((action: GetBanners) => action.payload),
			mergeMap((payload) => {
				return this.rootService.getBanners(payload).pipe(
					map((response) => {
						return new GetBannersSuccess(response)
					}),
					catchError((error) => of(new GetBannersError(error))))
			})
		)
	});
	// );

	// @Effect({ dispatch: false })
	// GetBannersSuccess$ = this.actions$.pipe(
	GetBannersSuccess$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.GetBannersSuccess),
			map((action: GetBannersSuccess) => action.payload),
			mergeMap((payload) => {
				return of(null)
			})
		)
	}, { dispatch: false });
	// );

	// @Effect({ dispatch: false })
	// GetBannersError$ = this.actions$.pipe(
	GetBannersError$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.GetBannersError),
			map((action: GetBannersError) => action.payload),
			mergeMap((payload) => {
				this.helper.Error$(payload);
				return of(null)
			})
		)
	}, { dispatch: false });
	// );

	// @Effect()
	// GetBannersForProduct$ = this.actions$.pipe(
	GetBannersForProduct$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.GetBannersForProduct),
			map((action: GetBannersForProduct) => action.payload),
			mergeMap((payload) => {
				return this.rootService.getBanners(payload).pipe(
					map((response) => {
						return new GetBannersForProductSuccess(response)
					}),
					catchError((error) => of(new GetBannersForProductError(error))))
			})
		)
	});
	// );

	// @Effect({ dispatch: false })
	// GetBannersForProductSuccess$ = this.actions$.pipe(
	GetBannersForProductSuccess$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.GetBannersForProductSuccess),
			map((action: GetBannersForProductSuccess) => action.payload),
			mergeMap((payload) => {
				return of(null)
			})
		)
	}, { dispatch: false });
	// );

	// @Effect({ dispatch: false })
	// GetBannersForProductError$ = this.actions$.pipe(
	GetBannersForProductError$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.GetBannersForProductError),
			map((action: GetBannersForProductError) => action.payload),
			mergeMap((payload) => {
				this.helper.Error$(payload);
				return of(null)
			})
		)
	}, { dispatch: false });
	// );

	// @Effect()
	// GetBannersForStore$ = this.actions$.pipe(
	GetBannersForStore$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.GetBannersForStore),
			map((action: GetBannersForStore) => action.payload),
			mergeMap((payload) => {
				return this.rootService.getBanners(payload).pipe(
					map((response) => {
						return new GetBannersForStoreSuccess(response)
					}),
					catchError((error) => of(new GetBannersForStoreError(error))))
			})
		)
	});
	// );

	// @Effect({ dispatch: false })
	// GetBannersForStoreSuccess$ = this.actions$.pipe(
	GetBannersForStoreSuccess$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.GetBannersForStoreSuccess),
			map((action: GetBannersForStoreSuccess) => action.payload),
			mergeMap((payload) => {
				return of(null)
			})
		)
	}, { dispatch: false });
	// );

	// @Effect({ dispatch: false })
	// GetBannersForStoreError$ = this.actions$.pipe(
	GetBannersForStoreError$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.GetBannersForStoreError),
			map((action: GetBannersForStoreError) => action.payload),
			mergeMap((payload) => {
				this.helper.Error$(payload);
				return of(null)
			})
		)
	}, { dispatch: false });
	// );

	// @Effect()
	// GetPopularJewellers$ = this.actions$.pipe(
	GetPopularJewellers$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.GetPopularJewellers),
			map((action: GetPopularJewellers) => action.payload),
			mergeMap((payload) => {
				return this.rootService.getPopularJewellers(payload).pipe(
					map((response) => {
						return new GetPopularJewellersSuccess(response)
					}),
					catchError((error) => of(new GetPopularJewellersError(error))))
			})
		)
	});
	// );

	// @Effect({ dispatch: false })
	// GetPopularJewellersSuccess$ = this.actions$.pipe(
	GetPopularJewellersSuccess$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.GetPopularJewellersSuccess),
			map((action: GetPopularJewellersSuccess) => action.payload),
			mergeMap((payload) => {
				return of(null)
			})
		)
	}, { dispatch: false });
	// );

	// @Effect({ dispatch: false })
	// GetPopularJewellersError$ = this.actions$.pipe(
	GetPopularJewellersError$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.GetPopularJewellersError),
			map((action: GetPopularJewellersError) => action.payload),
			mergeMap((payload) => {
				this.helper.Error$(payload);
				return of(null)
			})
		)
	}, { dispatch: false });
	// );

	constructor(
		private actions$: Actions,
		private helper: Helper,
		private rootService: RootService,
	) {
	}
}
